
namespace RioERP.Orders {
    export class OrderProductBillingItemsTaxColumns {
        static columnsKey = 'Orders.OrderProductBillingItemsTax';
    }
}